import { isUserLoggedIn } from '../../utils/authUtils';
import { CrudServiceBase } from '../base/crudServiceBase';
import { PagedResultRequestDto } from '../base/pagedResultRequestDto';
import Endpoint from '../endpoint';
import { httpApi } from '../httpService';
import { ReferralDto } from './dto/referralDto';

export class ReferralService extends CrudServiceBase<ReferralDto> {
    constructor() {
        super(Endpoint.Referral);
        this.internalHttp = httpApi;
    }

    public async getAllReferrals(pagedFilterAndSortedRequest: PagedResultRequestDto = this.defaultRequest) {
        isUserLoggedIn();
        let result = await this.internalHttp.get(this.endpoint.Custom(`GetAllReferrals`), { params: pagedFilterAndSortedRequest });
        return !!result.data && !!result.data.result ? result.data.result : result.data;
    }

    public async paidBonusByReferralInvite(clientId: number, referralContestId: number, bonusType: string, sendedDate: string, isSendedToClient: boolean) {
        isUserLoggedIn();

        const newBonusPaidByReferralInviteInput: any = {
            clientId: clientId,
            referralContestId: referralContestId,
            bonusType: bonusType,
            sendedDate: sendedDate,
            isSendedToClient: isSendedToClient,
        };

        let result = await this.internalHttp.post(this.endpoint.Custom('PaidBonusByReferralInvite'), newBonusPaidByReferralInviteInput);
        return !!result.data && !!result.data.result ? result.data.result : result.data;
    }
}

const exportReferralService: ReferralService = new ReferralService();
export default exportReferralService;